import { render, staticRenderFns } from "./LastMessage.vue?vue&type=template&id=2f1aa9de&scoped=true&"
import script from "./LastMessage.vue?vue&type=script&lang=js&"
export * from "./LastMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1aa9de",
  null
  
)

export default component.exports